import React from 'react';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import { NODE_COLORS } from '../../config/theme';
import TextEditorModal from './TextEditorModal';

export default function ChatPromptEditor({ open, onClose, value = '', onSave }) {
  return (
    <TextEditorModal
      open={open}
      onClose={onClose}
      title="BI Context"
      nodeIcon={<ForumOutlinedIcon sx={{ fontSize: 16 }} />}
      nodeColor={NODE_COLORS.AI}
      value={value}
      onSave={onSave}
      placeholder={"Describe this project's data for the BI assistant.\n\nExplain what this project tracks, what its records mean, and any domain terms or nuances the assistant should know when analyzing it.\n\nThis text is injected into the workspace BI prompt template (via {{project_contexts}}) whenever this project is in scope.\n\nExample:\nThis project tracks freezing cards. Each job is one card; base_output holds the product list and confirmation status."}
    />
  );
}
